import { Modal } from '@trarc/pc-shared';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppContainerContext } from '../../contexts/AppContainerContext';
import { useSessionContext } from '../../contexts/SessionContext';
import { ButtonTitle, StyledLink, Title } from './ContactUsModal.styles';

export const ContactUsModal = ({ open, onClose }: { open: boolean; onClose?: () => void }) => {
  const { t } = useTranslation();
  const { setShowContactModal } = useAppContainerContext();
  const { hasComplianceDealership } = useSessionContext();
  const supportEmail = 'Support@Protontechs.com';

  return (
    <Modal open={open} onClose={onClose ?? (() => setShowContactModal(false))}>
      <Title>{t('contactUs.title')}</Title>
      <StyledLink href={`mailto:${supportEmail}`}>
        <ButtonTitle>{t('contactUs.emailUs.title')}</ButtonTitle>
        <div>{t('contactUs.emailUs.description', { email: supportEmail })}</div>
      </StyledLink>
      {hasComplianceDealership && (
        <StyledLink href="https://calendar.app.google/BSogC8B88JGb9Pib8" target="_blank">
          <ButtonTitle>{t('contactUs.scheduleAppointment.title')}</ButtonTitle>
          <div>{t('contactUs.scheduleAppointment.description')}</div>
        </StyledLink>
      )}
    </Modal>
  );
};
